export const dict = {
    DefaultPoints: "T",
    TennisPoints: "Points",
    Versus: "vs",
    StartsIn: "Starts in:",
    Overtime: "OT",
    FirstOvertime: "ET1",
    SecondOvertime: "ET2",
    BreakAfterFirstOvertime: "Break",
    BreakAfterSecondOvertime: "Break",
    FirstSet: "1st set",
    SecondSet: "2nd set",
    ThirdSet: "3rd set",
    FourthSet: "4th set",
    FifthSet: "5th set",
    FirstPeriod: "P1",
    SecondPeriod: "P2",
    ThirdPeriod: "P3",
    BreakAfterFirstPeriod: "INT1",
    BreakAfterSecondPeriod: "INT2",
    BreakAfterThirdPeriod: "INT3",
    FirstQuarter: "Q1",
    SecondQuarter: "Q2",
    ThirdQuarter: "Q3",
    FourthQuarter: "Q4",
    BreakAfterFirstQuarter: "Break",
    BreakAfterSecondQuarter: "Break",
    BreakAfterThirdQuarter: "Break",
    BreakAfterFourthQuarter: "Break",
    FirstHalf: "H1",
    SecondHalf: "H2",
    BreakAfterFirstHalf: "Break",
    FirstInning: "1st Inn",
    SecondInning: "2nd Inn",
    ThirdInning: "3rd Inn",
    FourthInning: "4th Inn",
    FifthInning: "5th Inn",
    SixthInning: "6th Inn",
    SeventhInning: "7th Inn",
    EighthInning: "8th Inn",
    NinthInning: "9th Inn",
    TenthInning: "10th Inn",
    EleventhInning: "11th Inn",
    TwelfthInning: "12th Inn",
    ThirteenthInning: "13th Inn",
    FourteenthInning: "14th Inn",
    FifteenthInning: "15th Inn",
    BreakAfterFirstInning: "Break",
    BreakAfterSecondInning: "Break",
    BreakAfterThirdInning: "Break",
    BreakAfterFourthInning: "Break",
    BreakAfterFifthInning: "Break",
    BreakAfterSixthInning: "Break",
    BreakAfterSeventhInning: "Break",
    BreakAfterEighthInning: "Break",
    BreakAfterNinthInning: "Break",
    BreakAfterTenthInning: "Break",
    BreakAfterEleventhInning: "Break",
    BreakAfterTwelfthInning: "Break",
    BreakAfterThirteenthInning: "Break",
    BreakAfterFourteenthInning: "Break",
    FirstFrame: "1st Frame",
    SecondFrame: "2nd Frame",
    ThirdFrame: "3rd Frame",
    FourthFrame: "4th Frame",
    FifthFrame: "5th Frame",
    Finished: "FT",
    PenaltyShootout: "PEN",
    FirstHalfHeader: "H1",
    SecondHalfHeader: "H2",
    HalfTimeHeader: "HT",
    FirstQuarterHeader: "Q1",
    SecondQuarterHeader: "Q2",
    ThirdQuarterHeader: "Q3",
    FourthQuarterHeader: "Q4",
    OvertimeHeader: "OT",
    SecondOvertimeHeader: "OT2",
    FirstPeriodHeader: "1st",
    SecondPeriodHeader: "2nd",
    ThirdPeriodHeader: "3rd",
    FirstSetHeader: "1",
    SecondSetHeader: "2",
    ThirdSetHeader: "3",
    FourthSetHeader: "4",
    FifthSetHeader: "5",
    FirstInningHeader: "1",
    SecondInningHeader: "2",
    ThirdInningHeader: "3",
    FourthInningHeader: "4",
    FifthInningHeader: "5",
    SixthInningHeader: "6",
    SeventhInningHeader: "7",
    EighthInningHeader: "8",
    NinthInningHeader: "9",
    TenthInningHeader: "10",
    EleventhInningHeader: "11",
    TwelfthInningHeader: "12",
    ThirteenthInningHeader: "13",
    FourteenthInningHeader: "14",
    FifteenthInningHeader: "15",
    BaseballResultHeader: "R",
    BaseballHitsHeader: "H",
    BaseballBallsHeader: "B",
    BaseballStrikesHeader: "S",
    BaseballOutsHeader: "O",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    Sunday: "Sunday",
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December"
};
//# sourceMappingURL=dict.js.map